import React from "react";
import DatePicker from 'material-ui/DatePicker';
import './style.css';
import RaisedButton from "material-ui/RaisedButton";
import { translate } from "admin-on-rest";
import ExportIcon from "./ExportIcon";


const styles = {
  headerDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    boxShadow: 'rgba(0, 0, 0, 0.5) 0px 2px 5px 1px',
    alignItems: 'center',
    marginBottom: '16px'
  },
  headerText: {
    padding: '16px',
    fontWeight: 400,
    fontSize: '24px',
    margin: 0
  },
  filter: {
    display: 'flex'
  },
  datePicker: {
    padding: '0 10px'
  },
  buttonDiv: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    padding: '10px 15px',
    borderRadius: 2,
    fontSize: '16px',
    backgroundColor: 'rgb(109, 199, 195)',
    boxShadow: 'rgba(0, 0, 0, 0.5) 0px 2px 5px 1px',
    color: 'white',
    border: 0
  }
}

const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
class CashbackerAnalyticsDataListBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: null,
      toDate: null
    }
    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
    this.download = this.download.bind(this);
    this.handleErrorResponse = this.handleErrorResponse.bind(this);
  }

  handleFromChange(_, originalDate) {
    const date = (new Date(originalDate - tzoffset)).toISOString().substring(0, 10);
    this.setState({ fromDate: date });
  }

  handleToChange(_, originalDate) {
    const date = (new Date(originalDate - tzoffset)).toISOString().substring(0, 10);
    this.setState({ toDate: date });
  }

  download() {
    const { fromDate, toDate } = this.state;
    const token = localStorage.getItem('token');    

    if (fromDate && toDate) {

      let anchor = document.createElement("a");
      document.body.appendChild(anchor);

      fetch(`${process.env.REACT_APP_API_URL}/reporting/cashbacker_campaign_registrations?date_from=${fromDate}&date_to=${toDate}`, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })
      .then(response => {
        if(response.status === 400){
          return response.json();
        } else {
          return response.blob();
        }
      })
      .then(data => {
        if(data.errors){
          this.handleErrorResponse(data.errors);
        } else {
          const blobby = data;
          const objectUrl = URL.createObjectURL(blobby);
          anchor.href = objectUrl;
          anchor.download = `${fromDate}_${toDate}.xlsx`;
          anchor.click();
          URL.revokeObjectURL(objectUrl);
        }
      })
      .catch(error => {
        console.error(error);
      });
    } else {
      this.handleErrorResponse();
    }
  }

  handleErrorResponse(errors){
    const {translate} = this.props;

    if (document.getElementById('errorDiv').innerHTML) {
      return '';
    } else {
      if(errors){
        const div = document.createElement("div");
        const errMsg = (errors && errors.length) ? errors[0].detail : null;
        const errorText = document.createTextNode(errMsg);
        div.appendChild(errorText);
        document.getElementById('errorDiv').appendChild(div);
      } else {
        const div = document.createElement("div");
        const errMsg = translate("resources.reports.chooseBothDates");
        const errorText = document.createTextNode(errMsg);
        div.appendChild(errorText);
        document.getElementById('errorDiv').appendChild(div);
      }      
    }
  }

  render() {
    const {translate} = this.props;
    return (
      <React.Fragment>
        <div style={styles.headerDiv}>
          <div>
            <h1 style={styles.headerText}>{translate("resources.reports.cashbackerCampaignRegistrationsReportsTitle")}</h1>
          </div>
          <div style={styles.filter} id="datePickerDiv">
            <DatePicker
              floatingLabelText={translate("resources.reports.dateFrom")}
              autoOk={true}
              container="inline"
              style={styles.datePicker}
              onChange={this.handleFromChange}
            />
            <DatePicker
              floatingLabelText={translate("resources.reports.dateTo")}
              autoOk={true}
              container="inline"
              style={styles.datePicker}
              onChange={this.handleToChange} 
            />
          </div>
        </div>
        <div id="errorDiv" />
        <div style={styles.buttonDiv}>
          <RaisedButton 
            id="export"
            type="submit"
            label={translate("resources.reports.exportAction")}
            primary
            icon={<ExportIcon />}
            onClick={this.download}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default translate(CashbackerAnalyticsDataListBase);



// WEBPACK FOOTER //
// ./src/containers/CRM/AnalyticsData/CashbackerCampaignRegistrationsAnalyticsDataList.js